import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

export const useLayoutDispatch = () => useDispatch<AppDispatch>();
export const useLayoutSelector: TypedUseSelectorHook<RootState> = useSelector;
